<template>
  <el-tabs type="border-card" class="custom-tab" v-model="activeName">
    <el-tab-pane label="订单列表" name="a">
      <Order v-if="activeName === 'a'" :activeName="activeName"/>
    </el-tab-pane>
    <el-tab-pane label="报价列表" name="b">
      <quotation  v-if="activeName === 'b'" :activeName="activeName"/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { defineComponent,ref } from '@vue/composition-api'
import Order from './order.vue'
import quotation from './quotation.vue'


export default defineComponent({
  components: {Order,quotation},
  setup() {
    const activeName = ref('a')

    return {
      activeName,
    }
  }

})
</script>
